module.exports = __webpack_public_path__ + "51260448a1dcb51b06ae83c9a51a19e4.pdf";